import type { Emotion, Papers } from "./catalog";

export type Preset = "idle" | "waiting" | "busySorting" | "celebrate" | "napping" | "puzzled";

export const PRESETS: Record<Preset, { emotion: Emotion; papers: Papers }> = {
  idle: { emotion: "neutral", papers: "none" },
  waiting: { emotion: "neutral", papers: "messy" },
  busySorting: { emotion: "searching", papers: "orbiting" },
  celebrate: { emotion: "happy", papers: "neat" },
  napping: { emotion: "sleeping", papers: "none" },
  puzzled: { emotion: "confused", papers: "messy" },
};

export function resolveKnobs(
  preset: Preset | undefined,
  emotion: Emotion | undefined,
  papers: Papers | undefined,
): { emotion: Emotion; papers: Papers } {
  if (preset) return PRESETS[preset];
  return { emotion: emotion ?? "neutral", papers: papers ?? "none" };
}
